import React from 'react';
import {Card} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Group from 'material-ui/svg-icons/social/group';
import "./Counter.css";

import LinearProgress from 'material-ui/LinearProgress';

class Counter extends React.Component {
    constructor(props) {
        super(props);            
        this.state = {
            count: <div style={{height:"30px",paddingTop:"15px"}}><LinearProgress style={{width:"50%",float:"right"}} mode="indeterminate" /></div>,
            label: props.label,
            color: props.color,
            icon: props.icon
        };    
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.count)
            this.setState({ count: nextProps.count.toLocaleString("pt-BR") });
    }

    render(){
        var mainIconStyle = {width:"50px",height:"50px",color:"white"};
        var headStyle = {marginTop:"-30px"};
        var cardStyle = {marginTop:"50px"};   
        
        var count = this.state.count; 
        var label = this.state.label; 
        var color = this.state.color;
        var Icon = this.state.icon; 
        return (            
            <div>
            <Card style={cardStyle} className="card card-stats">
                <div style={headStyle} className="card-header" data-background-color={color}>
                <Icon style={mainIconStyle} />            
                </div>
                <div  className="card-content">
                <p className="category">{label}</p>
                <h3 className="title">
                    {count}
                </h3>
                </div>
                <div className="card-footer">
                <div style={{textAlign:"right"}} className="stats">
                    Atualização em tempo real                
                </div>
                </div>
            </Card>
            </div>
        )
    }
};

export default Counter;


// WEBPACK FOOTER //
// ./src/pages/parts/Counter.js